export default __webpack_public_path__ + "static/media/location-nyc.41bfc7fc.jpg";